(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Trashie revamp 2026-05-12: clear the scroll-hide state on
  // `.section-header` the moment the drawer starts closing, so the header
  // stays visible instead of animating back to its pre-menu hidden state.
  // We observe the `menu-opening` class on the details element rather than
  // the native `toggle` event because Dawn's closeAnimation() defers the
  // `open` attribute removal by 400ms — listening to `toggle` produces a
  // visible 0.15s flicker as the header animates to top:-68 in that gap.
  // StickyHeader.onScroll re-applies the hidden state on the next scroll-
  // down by the user, so this only suppresses the close-time flicker.
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return;
    var hadOpening = drawer.classList.contains('menu-opening');
    new MutationObserver(function () {
      var hasOpening = drawer.classList.contains('menu-opening');
      if (hadOpening && !hasOpening) {
        var section = document.querySelector('.section-header');
        if (section) section.classList.remove('shopify-section-header-hidden');
      }
      hadOpening = hasOpening;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Trashie revamp 2026-05-12: re-wire the X close button to fully close
    // the drawer. Dawn's MenuDrawer.bindEvents binds onCloseButtonClick to
    // EVERY button inside the drawer (assets/global.js:362-364), and
    // onCloseButtonClick → closeSubmenu only handles nested submenu collapse.
    // For the top-level drawer's X, this animates the drawer out but never
    // calls closeMenuDrawer, so `.section-header.menu-open`, body's
    // `overflow-hidden-tablet`, and the padding-top compensator all stay
    // stuck. Intercept the click at capture phase and simulate a summary
    // click instead, which routes through Dawn's onSummaryClick →
    // closeMenuDrawer for a clean state teardown.
    var closeBtn = drawer.querySelector('.menu-drawer__close');
    var summary = drawer.querySelector(':scope > summary');
    if (closeBtn && summary) {
      closeBtn.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        summary.click();
      }, true);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
